/**
 * Group-wide Sales page — renders SalesModule without a division filter.
 * Only accessible to CEO / CXO / admin.
 *
 * NOTE: Group F&B Cost tile lives on /division/me (MindEscapes) — it's a
 * single-division operational metric, not a group-pipeline metric.
 */
import SalesModule from '@/components/SalesModule';

export default function GroupSalesPage() {
  return (
    <div className="max-w-7xl mx-auto p-3 sm:p-5">
      <SalesModule divisionId={null} divisionName="Group (All Divisions)" isCEO={true} />
    </div>
  );
}
